import { SubHeading } from "../../components";
import { images } from "../../constants";
import "./Header.css";

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Chase the new flavour" />
      <h1 className="app__header-h1">Nyckeln till att hitta mat</h1>
      <p className="p__opensans" style={{ margin: "2rem 0" }}>
        Nyckeln till att hitta mat ligger i att upptäcka olika kök, utforska
        lokala marknader och vara öppen för nya smaker och kulinariska äventyr
        runt om i världen.
      </p>
      <button type="button" className="custom__button">
        Utforska Menyn
      </button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.welcome} alt="header img" />
    </div>
  </div>
);

export default Header;
